<ap-findcontrol [baseId]="Id + 'fndControl'"
                  [findControlId]="findcontrolType"
                  [selectedPks]="list"
                  [placeHolder]="" 
                  [disabled]="isDisable" 
                  [singleSelect]="isSingleSelect"
                  (selectedPksChange)="onChange($event)"
                 >
                </ap-findcontrol>